export const GIS_LOAD_MAX_ATTEMPTS = 300;
export const GIS_POLL_INTERVAL_MS = 100;

export const GIS_BUTTON_DEFAULTS = {
  minWidth: 240,
  maxWidth: 400,
  fallbackWidth: 320,
};

/** Returns the Google Identity Services `accounts.id` API when available. */
export function getGoogleIdentityService() {
  if (typeof window === "undefined") return undefined;
  return window.google?.accounts?.id;
}

/** Clamp GIS button width to Google's supported range for the sign-in button. */
export function computeGoogleButtonWidth(
  wrapWidth,
  { minWidth = GIS_BUTTON_DEFAULTS.minWidth, maxWidth = GIS_BUTTON_DEFAULTS.maxWidth, fallbackWidth = GIS_BUTTON_DEFAULTS.fallbackWidth } = {},
) {
  return Math.min(Math.max(wrapWidth || fallbackWidth, minWidth), maxWidth);
}

/** Build options passed to `google.accounts.id.initialize`. */
export function buildGoogleInitOptions({ clientId, callback, useRedirect, origin }) {
  const initOpts = {
    client_id: clientId,
    callback,
    ux_mode: useRedirect ? "redirect" : "popup",
    auto_select: false,
    itp_support: true,
  };
  if (useRedirect) {
    initOpts.login_uri = `${origin}/api/auth/google/callback`;
  }
  return initOpts;
}

/** Options passed to `google.accounts.id.renderButton`. */
export function buildGoogleButtonRenderOptions(width) {
  return {
    type: "standard",
    theme: "filled_black",
    text: "continue_with",
    shape: "pill",
    size: "large",
    width,
  };
}

export const GIS_LOAD_TIMEOUT_MESSAGE =
  "Google sign-in failed to load. Check your network or ad blocker, then try again.";
